// extracted by mini-css-extract-plugin
export default {"links":"LinkVideos_links__a2fUk","anchor":"LinkVideos_anchor__InTB9"};